var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade-up"},on:{"after-enter":_vm.resetLock,"after-leave":_vm.resetLock}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.lock),expression:"!lock"}],staticClass:"text-rotator"},[_vm._v(_vm._s(_vm.currentText))])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-760637da","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TextRotator.vue
// module id = null
// module chunks = 